import { jsxs as r, jsx as i } from "react/jsx-runtime";
import e from "../svg-icon/svg-icon.component.js";
function o(a) {
  return /* @__PURE__ */ r(
    e,
    {
      width: "48",
      height: "48",
      viewBox: "0 0 48 48",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...a,
      children: [
        /* @__PURE__ */ i(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.19621 10.5248C7.51267 9.89186 8.28228 9.63532 8.91519 9.95178L10.4456 10.717C11.0785 11.0334 11.335 11.803 11.0186 12.4359C10.7021 13.0689 9.9325 13.3254 9.29959 13.0089L7.76921 12.2437C7.1363 11.9273 6.87976 11.1577 7.19621 10.5248Z",
            fill: "url(#paint0_radial_37120_172)"
          }
        ),
        /* @__PURE__ */ i(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4 17.2193C4 16.5117 4.57364 15.938 5.28125 15.938H6.81163C7.51925 15.938 8.09288 16.5117 8.09288 17.2193C8.09288 17.9269 7.51925 18.5005 6.81163 18.5005H5.28125C4.57364 18.5005 4 17.9269 4 17.2193Z",
            fill: "url(#paint1_radial_37120_172)"
          }
        ),
        /* @__PURE__ */ i(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M24.0757 12.3787C19.1155 12.3787 15.0967 16.3949 15.0967 21.3475V28.1808C15.0967 30.2536 14.1569 32.215 12.5383 33.5141L12.0105 33.9377C11.3895 34.4361 11.7398 35.4412 12.541 35.4412H35.6103C36.4116 35.4412 36.7618 34.4361 36.1409 33.9377L35.613 33.5141C33.9973 32.2157 33.0547 30.2543 33.0547 28.1808V21.3475C33.0547 16.3949 29.0358 12.3787 24.0757 12.3787ZM12.5342 21.3475C12.5342 14.9772 17.7028 9.81623 24.0757 9.81623C30.4486 9.81623 35.6172 14.9772 35.6172 21.3475V28.1808C35.6172 29.4759 36.2055 30.7025 37.2169 31.5156L37.7448 31.9393C40.2569 33.9556 38.8271 38.0037 35.6103 38.0037H12.541C9.32425 38.0037 7.89439 33.9556 10.4065 31.9393L10.9344 31.5156C11.9467 30.7032 12.5342 29.4769 12.5342 28.1808V21.3475Z",
            fill: "url(#paint2_radial_37120_172)"
          }
        ),
        /* @__PURE__ */ i(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M20.2319 41.8475C20.2319 41.1399 20.8056 40.5662 21.5132 40.5662H26.6382C27.3458 40.5662 27.9194 41.1399 27.9194 41.8475C27.9194 42.5551 27.3458 43.1287 26.6382 43.1287H21.5132C20.8056 43.1287 20.2319 42.5551 20.2319 41.8475Z",
            fill: "url(#paint3_radial_37120_172)"
          }
        ),
        /* @__PURE__ */ i(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M40.4163 10.5248C40.7327 11.1577 40.4762 11.9273 39.8433 12.2437L38.3129 13.0089C37.68 13.3254 36.9104 13.0689 36.5939 12.4359C36.2775 11.803 36.534 11.0334 37.1669 10.717L38.6973 9.95178C39.3302 9.63532 40.0998 9.89186 40.4163 10.5248Z",
            fill: "url(#paint4_radial_37120_172)"
          }
        ),
        /* @__PURE__ */ i(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M39.5197 17.2193C39.5197 16.5117 40.0933 15.938 40.8009 15.938H42.3313C43.0389 15.938 43.6125 16.5117 43.6125 17.2193C43.6125 17.9269 43.0389 18.5005 42.3313 18.5005H40.8009C40.0933 18.5005 39.5197 17.9269 39.5197 17.2193Z",
            fill: "url(#paint5_radial_37120_172)"
          }
        ),
        /* @__PURE__ */ r("defs", { children: [
          /* @__PURE__ */ r(
            "radialGradient",
            {
              id: "paint0_radial_37120_172",
              cx: "0",
              cy: "0",
              r: "1",
              gradientTransform: "matrix(-4.954 3.32825 -4.09344 -4.02794 11.6658 9.81623)",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ i("stop", { stopColor: "#FFCD5C" }),
                /* @__PURE__ */ i("stop", { offset: "1", stopColor: "#FF5D47" })
              ]
            }
          ),
          /* @__PURE__ */ r(
            "radialGradient",
            {
              id: "paint1_radial_37120_172",
              cx: "0",
              cy: "0",
              r: "1",
              gradientTransform: "matrix(-4.95332 2.5625 -4.09288 -3.10121 8.60449 15.938)",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ i("stop", { stopColor: "#FFCD5C" }),
                /* @__PURE__ */ i("stop", { offset: "1", stopColor: "#FF5D47" })
              ]
            }
          ),
          /* @__PURE__ */ r(
            "radialGradient",
            {
              id: "paint2_radial_37120_172",
              cx: "0",
              cy: "0",
              r: "1",
              gradientTransform: "matrix(-36.1874 28.1875 -29.9013 -34.1133 42.764 9.81623)",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ i("stop", { stopColor: "#FFCD5C" }),
                /* @__PURE__ */ i("stop", { offset: "1", stopColor: "#FF5D47" })
              ]
            }
          ),
          /* @__PURE__ */ r(
            "radialGradient",
            {
              id: "paint3_radial_37120_172",
              cx: "0",
              cy: "0",
              r: "1",
              gradientTransform: "matrix(-9.30362 2.5625 -7.6875 -3.10121 28.8804 40.5662)",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ i("stop", { stopColor: "#FFCD5C" }),
                /* @__PURE__ */ i("stop", { offset: "1", stopColor: "#FF5D47" })
              ]
            }
          ),
          /* @__PURE__ */ r(
            "radialGradient",
            {
              id: "paint4_radial_37120_172",
              cx: "0",
              cy: "0",
              r: "1",
              gradientTransform: "matrix(-4.954 3.32825 -4.09344 -4.02794 41.0635 9.81623)",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ i("stop", { stopColor: "#FFCD5C" }),
                /* @__PURE__ */ i("stop", { offset: "1", stopColor: "#FF5D47" })
              ]
            }
          ),
          /* @__PURE__ */ r(
            "radialGradient",
            {
              id: "paint5_radial_37120_172",
              cx: "0",
              cy: "0",
              r: "1",
              gradientTransform: "matrix(-4.95332 2.5625 -4.09288 -3.10121 44.1241 15.938)",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ i("stop", { stopColor: "#FFCD5C" }),
                /* @__PURE__ */ i("stop", { offset: "1", stopColor: "#FF5D47" })
              ]
            }
          )
        ] })
      ]
    }
  );
}
export {
  o as NotificationActivePictogramPictogram
};
//# sourceMappingURL=notification-active-pictogram.js.map
